import { render, staticRenderFns } from "./msgmanage.vue?vue&type=template&id=2fc0167a&scoped=true&"
import script from "./msgmanage.vue?vue&type=script&lang=js&"
export * from "./msgmanage.vue?vue&type=script&lang=js&"
import style0 from "./msgmanage.vue?vue&type=style&index=0&id=2fc0167a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0167a",
  null
  
)

export default component.exports